import React, { useEffect } from "react";
import { Table } from "react-bootstrap";
import NoData from "../Components/NoData";
import { capitalize } from "../Utils/commonFiles";
import PaginationComponent from "../Components/Pagination";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const SongTable = ({
  total,
  songs,
  currentPage,
  totalEntries,
  entriesPerPage,
  totalPages,
  handlePageChange,
  setSelectedSongs,
  selectedSongs,
  sortBy,
  sortOrder,
  handleSort,
}) => {
  const { maxsongcount } = useParams();
  const songAllList = useSelector((e) => e.songAuth.allCategorySongList);


  const handleSelectedSong = (selectedSongId) => {
    if (selectedSongs.includes(selectedSongId)) {
      setSelectedSongs(selectedSongs.filter((song) => song !== selectedSongId));
    } else if (selectedSongs.length < parseInt(maxsongcount)) {
      setSelectedSongs([...selectedSongs, selectedSongId]);
    } else {
      toast.error(`You can select up to ${maxsongcount} songs only.`);
    }
  };

  useEffect(() => {
    if (songAllList?.songs?.length > 0 && songs?.length > 0) {
      const preSelectedSongs = songs
        .filter((s) => songAllList.songs.some((song) => song._id === s._id))
        .map((s) => s._id);

      setSelectedSongs((prev) => {
        const merged = Array.from(
          new Set([...prev, ...preSelectedSongs])
        ).slice(0, parseInt(maxsongcount));
        return merged;
      });
    }
  }, [songAllList, songs, maxsongcount, setSelectedSongs]);

  const genreOptions = {
    Popular_chart: "Popular/Chart",
    Film_tv: "Film/TV",
    Jazz: "Jazz",
    Classical: "Classical",
  };

  return (
    <div className="filters mt-0">
      <div className="inner-filter-field">
        <div className="table-responsive">
          <Table size="sm" className="table-cmn">
            <thead>
              <tr>
                <th
                  onClick={() => handleSort("title")}
                  style={{ cursor: "pointer" }}
                >
                  Song Name{" "}
                  <span>
                    {sortBy === "title"
                      ? sortOrder === "asc"
                        ? "↑"
                        : "↓"
                      : "↑"}
                  </span>
                </th>
                <th
                  onClick={() => handleSort("musicianName")}
                  style={{ cursor: "pointer" }}
                >
                  Artist{" "}
                  <span>
                    {sortBy === "musicianName"
                      ? sortOrder === "asc"
                        ? "↑"
                        : "↓"
                      : "↑"}
                  </span>
                </th>
                <th className="hide-on-mobile">Genre</th>
                <th>Select</th>
              </tr>
            </thead>
            <tbody>
              {songs?.length > 0 &&
                songs?.map((elem, i) => (
                  <tr key={i}>
                    <td>
                      <div className="first-user gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="36"
                          height="36"
                          viewBox="0 0 36 36"
                          fill="none"
                        >
                          <path
                            d="M25 10.6667V25.3333C25 25.5986 24.8946 25.8529 24.7071 26.0404C24.5196 26.228 24.2652 26.3333 24 26.3333C23.7348 26.3333 23.4804 26.228 23.2929 26.0404C23.1054 25.8529 23 25.5986 23 25.3333V10.6667C23 10.4015 23.1054 10.1471 23.2929 9.95956C23.4804 9.77202 23.7348 9.66667 24 9.66667C24.2652 9.66667 24.5196 9.77202 24.7071 9.95956C24.8946 10.1471 25 10.4015 25 10.6667ZM20 6C19.7348 6 19.4804 6.10536 19.2929 6.29289C19.1054 6.48043 19 6.73478 19 7V29C19 29.2652 19.1054 29.5196 19.2929 29.7071C19.4804 29.8946 19.7348 30 20 30C20.2652 30 20.5196 29.8946 20.7071 29.7071C20.8946 29.5196 21 29.2652 21 29V7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM28 13.3333C27.7348 13.3333 27.4804 13.4387 27.2929 13.6262C27.1054 13.8138 27 14.0681 27 14.3333V21C27 21.2652 27.1054 21.5196 27.2929 21.7071C27.4804 21.8946 27.7348 22 28 22C28.2652 22 28.5196 21.8946 28.7071 21.7071C28.8946 21.5196 29 21.2652 29 21V14.3333C29 14.0681 28.8946 13.8138 28.7071 13.6262C28.5196 13.4387 28.2652 13.3333 28 13.3333ZM16 10C15.7348 10 15.4804 10.1054 15.2929 10.2929C15.1054 10.4804 15 10.7348 15 11V25C15 25.2652 15.1054 25.5196 15.2929 25.7071C15.4804 25.8946 15.7348 26 16 26C16.2652 26 16.5196 25.8946 16.7071 25.7071C16.8946 25.5196 17 25.2652 17 25V11C17 10.7348 16.8946 10.4804 16.7071 10.2929C16.5196 10.1054 16.2652 10 16 10ZM12 13C11.7348 13 11.4804 13.1054 11.2929 13.2929C11.1054 13.4804 11 13.7348 11 14V22C11 22.2652 11.1054 22.5196 11.2929 22.7071C11.4804 22.8946 11.7348 23 12 23C12.2652 23 12.5196 22.8946 12.7071 22.7071C12.8946 22.5196 13 22.2652 13 22V14C13 13.7348 12.8946 13.4804 12.7071 13.2929C12.5196 13.1054 12.2652 13 12 13ZM8 15C7.73478 15 7.48043 15.1054 7.29289 15.2929C7.10536 15.4804 7 15.7348 7 16V20C7 20.2652 7.10536 20.5196 7.29289 20.7071C7.48043 20.8946 7.73478 21 8 21C8.26522 21 8.51957 20.8946 8.70711 20.7071C8.89464 20.5196 9 20.2652 9 20V16C9 15.7348 8.89464 15.4804 8.70711 15.2929C8.51957 15.1054 8.26522 15 8 15Z"
                            fill="#979699"
                          />
                        </svg>
                        <div className="user-profile">
                          {capitalize(elem?.title)}
                        </div>
                      </div>
                    </td>
                    <td>{capitalize(elem?.artist)}</td>
                    <td className="hide-on-mobile">
                      {genreOptions[elem?.genre] || "-"}
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        onChange={() => handleSelectedSong(elem?._id)}
                        checked={selectedSongs.includes(elem?._id)}
                        disabled={
                          !selectedSongs.includes(elem?._id) &&
                          selectedSongs.length >= parseInt(maxsongcount)
                        }
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
          {songs?.length === 0 && <NoData />}
          {total >= 1 && (
            <PaginationComponent
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              totalEntries={totalEntries}
              entriesPerPage={entriesPerPage}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SongTable;

// import React, { useEffect } from 'react'
// import { Table } from 'react-bootstrap'
// import NoData from '../Components/NoData';
// import { capitalize } from '../Utils/commonFiles';
// import PaginationComponent from '../Components/Pagination';
// import { useParams } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import { useSelector } from 'react-redux';

// const SongTable = ({ total, songs, currentPage, totalEntries, entriesPerPage, totalPages, handlePageChange, setSelectedSongs, selectedSongs, sortBy, sortOrder, handleSort, }) => {

//   const { maxsongcount } = useParams();
//   const songAllList = useSelector((e) => e.songAuth.allCategorySongList)

//   const handleSelectedSong = (selectedSongId) => {
//     if (selectedSongs.includes(selectedSongId)) {
//       setSelectedSongs(selectedSongs.filter(song => song !== selectedSongId));
//     } else if (selectedSongs.length < maxsongcount) {
//       setSelectedSongs([...selectedSongs, selectedSongId]);
//     } else {
//       toast.error(`You can select up to ${maxsongcount} songs only.`);
//     }
//   };

//   useEffect(() => {
//     if (songAllList?.songs?.length > 0 && songs?.length > 0) {
//       const preSelectedSongs = songs
//         .filter((s) => songAllList.songs.some((song) => song._id === s._id))
//         .map((s) => s._id)

//       const mergedSelectedSongs = Array.from(new Set([...selectedSongs, ...preSelectedSongs]));
//       setSelectedSongs([...mergedSelectedSongs]);
//     }
//   }, [songAllList, songs]);

//   const genreOptions = {
//     "Popular_chart": 'Popular/Chart',
//     "Film_tv": 'Film/TV',
//     'Jazz': "Jazz",
//     'Classical': "Classical",
//   };

//   return (
//     <div className="filters mt-0">
//       <div className="inner-filter-field">
//         <div className="table-responsive">
//           <Table size="sm" className="table-cmn">
//             <thead>
//               <tr>
//                  <th
//                   onClick={() => handleSort("title")}
//                   style={{ cursor: "pointer" }}
//                 >
//                   Song Name{" "}
//                      <span>{sortBy === "title" ? (sortOrder === "asc" ? "↑" : "↓") : "↑"}</span>
//                 </th>
//                 <th
//                   onClick={() => handleSort("musicianName")}
//                   style={{ cursor: "pointer" }}
//                 >
//                   Artist{" "}
//                    <span>{sortBy === "musicianName" ? (sortOrder === "asc" ? "↑" : "↓") : "↑"}</span>
//                 </th>
//                 <th className="hide-on-mobile">Genre</th>
//                 <th>Select</th>
//               </tr>
//             </thead>
//             <tbody>
//               {songs?.length > 0 &&
//                 songs?.map((elem, i) => (
//                   <tr key={i}>
//                     <td>
//                       <div className="first-user gap-2">
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="36"
//                           height="36"
//                           viewBox="0 0 36 36"
//                           fill="none"
//                         >
//                           <path
//                             d="M25 10.6667V25.3333C25 25.5986 24.8946 25.8529 24.7071 26.0404C24.5196 26.228 24.2652 26.3333 24 26.3333C23.7348 26.3333 23.4804 26.228 23.2929 26.0404C23.1054 25.8529 23 25.5986 23 25.3333V10.6667C23 10.4015 23.1054 10.1471 23.2929 9.95956C23.4804 9.77202 23.7348 9.66667 24 9.66667C24.2652 9.66667 24.5196 9.77202 24.7071 9.95956C24.8946 10.1471 25 10.4015 25 10.6667ZM20 6C19.7348 6 19.4804 6.10536 19.2929 6.29289C19.1054 6.48043 19 6.73478 19 7V29C19 29.2652 19.1054 29.5196 19.2929 29.7071C19.4804 29.8946 19.7348 30 20 30C20.2652 30 20.5196 29.8946 20.7071 29.7071C20.8946 29.5196 21 29.2652 21 29V7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM28 13.3333C27.7348 13.3333 27.4804 13.4387 27.2929 13.6262C27.1054 13.8138 27 14.0681 27 14.3333V21C27 21.2652 27.1054 21.5196 27.2929 21.7071C27.4804 21.8946 27.7348 22 28 22C28.2652 22 28.5196 21.8946 28.7071 21.7071C28.8946 21.5196 29 21.2652 29 21V14.3333C29 14.0681 28.8946 13.8138 28.7071 13.6262C28.5196 13.4387 28.2652 13.3333 28 13.3333ZM16 10C15.7348 10 15.4804 10.1054 15.2929 10.2929C15.1054 10.4804 15 10.7348 15 11V25C15 25.2652 15.1054 25.5196 15.2929 25.7071C15.4804 25.8946 15.7348 26 16 26C16.2652 26 16.5196 25.8946 16.7071 25.7071C16.8946 25.5196 17 25.2652 17 25V11C17 10.7348 16.8946 10.4804 16.7071 10.2929C16.5196 10.1054 16.2652 10 16 10ZM12 13C11.7348 13 11.4804 13.1054 11.2929 13.2929C11.1054 13.4804 11 13.7348 11 14V22C11 22.2652 11.1054 22.5196 11.2929 22.7071C11.4804 22.8946 11.7348 23 12 23C12.2652 23 12.5196 22.8946 12.7071 22.7071C12.8946 22.5196 13 22.2652 13 22V14C13 13.7348 12.8946 13.4804 12.7071 13.2929C12.5196 13.1054 12.2652 13 12 13ZM8 15C7.73478 15 7.48043 15.1054 7.29289 15.2929C7.10536 15.4804 7 15.7348 7 16V20C7 20.2652 7.10536 20.5196 7.29289 20.7071C7.48043 20.8946 7.73478 21 8 21C8.26522 21 8.51957 20.8946 8.70711 20.7071C8.89464 20.5196 9 20.2652 9 20V16C9 15.7348 8.89464 15.4804 8.70711 15.2929C8.51957 15.1054 8.26522 15 8 15Z"
//                             fill="#979699"
//                           />
//                         </svg>
//                         <div className="user-profile">
//                           {capitalize(elem?.title)}
//                         </div>
//                       </div>
//                     </td>
//                     <td>{capitalize(elem?.artist)}</td>
//                     <td className="hide-on-mobile">
//                       {genreOptions[elem?.genre] || "-"}
//                     </td>
//                     <td>
//                       <input
//                         type="checkbox"
//                         onChange={() => handleSelectedSong(elem?._id)}
//                         checked={selectedSongs.includes(elem?._id)}
//                       />
//                     </td>
//                   </tr>
//                 ))}
//             </tbody>
//           </Table>
//           {songs?.length == 0 && <NoData />}
//           {total >= 1 && (
//             <PaginationComponent
//               currentPage={currentPage}
//               totalPages={totalPages}
//               onPageChange={handlePageChange}
//               totalEntries={totalEntries}
//               entriesPerPage={entriesPerPage}
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default SongTable
